import React from "react"
import classnames from "classnames"
import { Input, A, SearchIcon } from "AtomicComponents"
import googleAutoComplete from "AtomicUtils/googleAutoComplete"
import styles from "./InputSearchable.less"
import fetchAPI from "AtomicUtils/fetchAPI"

class InputSearchable extends React.Component {
  constructor(props){
    super(props)
    this.postcode = null
    this.google = new googleAutoComplete()
    this.state = {
      places: [],
      dealers: [],
      showOptions: false,
      selected: {},
      hoverIndex: 0
    }
  }

  _onBlurHandler = () => {
    this.setState({
      places: [],
      showOptions: false
    }, () => {
      const { onBlur = () => { } } = this.props
      onBlur()
    })
  }

  _onFocusHandler = () => {
    this.setState({
      showOptions: true
    }, () => {
      const { onFocus = () => { } } = this.props
      onFocus()
    })
  }

  searchDealers = async (input = "", forceChange) => {
    const service = '/api/dealer-search'
    await fetchAPI({
      method: "POST",
      url: service,
      body: {
        searchText: input
      }
    })
    .then(async (response) => {
      const json = await response.json()
      const { success, data } = json
      if (success) {
        this.setState({
          showOptions: true,
          hoverIndex: 0,
          selected: {},
          dealers: data
        }, () => {
          if (forceChange &&
            this.state.dealers &&
            this.state.dealers.length > 0
          ) {
            this._onSelect(this.state.dealers[0])
          }
        })
      }
    })
  }

  _onChangeHandler = (value = "", forceChange = false) => {
    const { type = "postcode", onChange = () => {} } = this.props
    onChange()
    if (!value || value === "") {
      this.setState({
        showOptions: false,
        hoverIndex: 0,
        selected: {}
      })
      return
    }

    if (type === "dealer") {
      console.log("searching by dealer")
      this.searchDealers(value, forceChange)
    }

    if (type === "postcode" || type === "dealer") {
      console.log("searching by postcode or dealer")
      this.google.searchPostcode(value, (response) => {
        if (response && response.length > 0){
          this.setState({
             showOptions: true,
             hoverIndex: 0,
             selected: {},
             places: response.filter(item=>!item.types.includes("administrative_area_level_1"))
          }, () => {
            if (forceChange &&
              this.state.places &&
              this.state.places.length > 0
            ){
              this._onSelect(this.state.places[0])
            }
          })
        }
      })
    }
    if ( type === "address") {
      console.log("searching by address")
      this.google.searchAddress(value, (response) => {
        if (response && response.length > 0){
          this.setState({
             showOptions: true,
             selected: {},
             hoverIndex: 0,
             places: response.filter(item => !item.types.includes("administrative_area_level_1"))
          }, () => {
            if (forceChange &&
              this.state.places &&
              this.state.places.length > 0
            ) {
              this._onSelect(this.state.places[0])
            }
          })
        }
      })
    }
  }

  _getThisInput = (inputThis) => {
    const { getThisInput = () => { } } = this.props
    this.postcode = inputThis
    getThisInput(inputThis)
  }

  _onSelect = (item) => {
    const { onChange = () => { }, onBlur = () => { }, type = "postcode" } = this.props

    this.setState({
      places: [],
      dealers: [],
      showOptions: false,
      selected: item
    }, () => {

      if (item.display) {
        let selected = { ...this.state.selected }
        this.setState({
          selected: selected
        }, () => {
          onChange(this.state.selected)
          onBlur(this.state.selected)
        })
        this.postcode._onChangeOnlyValue(item.display)
      } else {
        this.google.getPostcode(item.description, (response) => {
          console.log('searching for a post code')
          if (response && response[0] && response[0].address_components) {
            let selected = {...this.state.selected}
            response[0].address_components.forEach(address => {
              if (address.types.includes("subpremise")) {
                selected.subpremise = address.short_name
              }
              if (address.types.includes("street_number")) {
                selected.streetNumber = address.short_name
              }
              if (address.types.includes("route")) {
                selected.route = address.short_name
              }
              if (address.types.includes("postal_code")) {
                selected.postcode = address.short_name
              } else if(item.description.match(/\d{4}/)) {
                selected.postcode = item.description.match(/\d{4}/)[0]
              }
              if (address.types.includes("locality")){
                selected.suburb = address.short_name
              }
              if (address.types.includes("administrative_area_level_1")) {
                selected.state = address.short_name
              }
            })
            this.setState({
              selected: selected
            }, () => {
              onChange(this.state.selected)
              onBlur(this.state.selected)
            })
          }
        })
        this.postcode._onChangeOnlyValue(item.description)
      }
    })
  }


  _onClickDownKey = () => {
    const { places, dealers, hoverIndex } = this.state
    if (dealers.length > 0) {
      if (dealers.length > hoverIndex) {
        this.setState({
          hoverIndex: hoverIndex + 1
        })
      }
    } else if (places.length > 0 ) {
      if (places.length > hoverIndex) {
        this.setState({
          hoverIndex: hoverIndex + 1
        })
      }
    }
  }

  _onClickUpKey = () => {
    const { places, dealers, hoverIndex } = this.state

    if (dealers.length > 0) {
      if (hoverIndex > 0) {
        this.setState({
          hoverIndex: hoverIndex - 1
        })
      }
    } else if (places.length > 0 ) {
      if (hoverIndex > 0) {
        this.setState({
          hoverIndex: hoverIndex - 1
        })
      }
    }
  }

  _onClickEnterKey = () => {
    const { places, dealers, hoverIndex } = this.state

    if (dealers && dealers.length > 0 && dealers[hoverIndex]) {
      this._onSelect(dealers[hoverIndex])
    } else if (places && places.length > 0 && places[hoverIndex]) {
      this._onSelect(places[hoverIndex])
    }
  }


  _onHover = (index) => {
    this.setState({
      hoverIndex: index
    })
  }


  render() {
    const { label, name, required, isValid, message, defaultValue } = this.props
    const { places, dealers, showOptions, hoverIndex } = this.state
    return (
      <div className={classnames({
        [styles.InputSearchable]: true
      })}>
        <Input
          label={label}
          getThisInput={this._getThisInput}
          name={name}
          disableEnter
          type='text'
          required={required}
          defaultValue={defaultValue}
          autoComplete={"new-password"}
          isValid={isValid}
          message={message}
          onChange={this._onChangeHandler}
          onBlur={this._onBlurHandler}
          onFocus={this._onFocusHandler}
          callOnChangeAfterBlur={false}
          onClickDownKey={this._onClickDownKey}
          onClickUpKey={this._onClickUpKey}
          onClickEnterKey={this._onClickEnterKey}
        />
        <div className={classnames({
          [styles.InputSearchableIcon]: true,
          [styles.InputSearchableIconInnerInvalid]: !isValid && message
        })}>
          <SearchIcon style={{
            width: "16px",
            height: "16px"
          }} />
        </div>
        {showOptions && places && places.length > 0 &&
          <div className={classnames({
            [styles.selectOptions]: true
          })}>
            <ul className={classnames({
              [styles.selectOptionsUL]: true
            })}>
              {dealers.length ? dealers.map((item,index) => {
                if (item && item.display)
                return (
                  <li
                    key={`SelectOptions-${item.value}`}
                    className={classnames({
                      [styles.selectOptionsLI]: true,
                      [styles.selectOptionsLIHover]: hoverIndex === index
                    })}
                  >
                    <A
                      withoutStyle
                      onClick={()=>{this._onSelect(item)}}
                      onMouseOver={()=>{this._onHover(index)}}
                    >
                      {item.display}
                    </A>
                  </li>
                )
              }) : null}
              {!dealers.length && places.map((item,index) => {
                if (item && item.structured_formatting && item.description)
                return (
                  <li
                    key={`SelectOptions-${item.place_id}`}
                    className={classnames({
                      [styles.selectOptionsLI]: true,
                      [styles.selectOptionsLIHover]: hoverIndex === index
                    })}
                  >
                    <A
                      withoutStyle
                      onClick={()=>{this._onSelect(item)}}
                      onMouseOver={()=>{this._onHover(index)}}
                    >
                      {item.description}
                    </A>
                  </li>
                )
              })}
            </ul>
          </div>
        }
      </div>
    )
  }
}


export default InputSearchable



// WEBPACK FOOTER //
// ./src/AtomicContainers/InputSearchable/InputSearchable.jsx